// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetCustomersRequestModel from '../../model/get-customers-request-model';
import GetCustomersRequestDTO from '../dto/get-customers-request-dto';

export default abstract class GetCustomersRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetCustomersRequestDTO>) {
    super();
    if (data) {
      this['paging.CurrentPage'] = data['paging.CurrentPage'];
      this['paging.PageSize'] = data['paging.PageSize'];
      this['paging.IncludeCount'] = data['paging.IncludeCount'];
      this['paging.NoPaging'] = data['paging.NoPaging'];
      this.employeeId = data.employeeId;
      this.searchCriteria = data.searchCriteria;
      this.customerNumber = data.customerNumber;
    }
  }
  /**
  * @type {int32}
  */
  'paging.CurrentPage'?: number;
  /**
  * @type {int32}
  */
  'paging.PageSize'?: number;
  /**
  */
  'paging.IncludeCount'?: boolean;
  /**
  */
  'paging.NoPaging'?: boolean;
  /**
  * @type {int64}
  */
  'employeeId'?: number;
  /**
  */
  'searchCriteria'?: string;
  /**
  */
  'customerNumber'?: string;

  static toModel(dto: DeepPartial<GetCustomersRequestDTO>): GetCustomersRequestModel;
  static toModel(dto: DeepPartial<GetCustomersRequestDTO> | undefined | null): GetCustomersRequestModel | undefined;
  static toModel(dto: DeepPartial<GetCustomersRequestDTO> | undefined | null): GetCustomersRequestModel | undefined {
    return dto ? new GetCustomersRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetCustomersRequestModel> | GetCustomersRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'paging.CurrentPage': unwrapped['paging.CurrentPage'],
      'paging.PageSize': unwrapped['paging.PageSize'],
      'paging.IncludeCount': unwrapped['paging.IncludeCount'],
      'paging.NoPaging': unwrapped['paging.NoPaging'],
      'employeeId': unwrapped.employeeId,
      'searchCriteria': unwrapped.searchCriteria,
      'customerNumber': unwrapped.customerNumber,
    } as GetCustomersRequestDTO;
  }
}
